<template>
  <div class="traffic-container">
    <div class="traffic_item mb_80">
      <div class="traffic_type">
          <div>1</div>
          <p class="flex-container">
            <span class="media_font_size_50">地铁</span>
            <span>Subway</span>
          </p>
      </div>
      <el-table :data="metroList" border  style="width: 100%;" header-cell-class-name="header-row" :cell-style="{textAlign: 'center'}">
        <el-table-column prop="line" label="地铁线路"></el-table-column>
        <el-table-column prop="station" label="下车地点"></el-table-column>
        <el-table-column prop="start" label="始发/终点站"></el-table-column>
        <el-table-column prop="time" label="首发/末班"></el-table-column>
        <el-table-column prop="fee" label="全部票价"></el-table-column>
      </el-table>
    </div>
    <div class="traffic_item">
      <div class="traffic_type">
          <div>2</div>
          <p class="flex-container">
            <span class="media_font_size_50">公交线路</span>
            <span>Bus</span>
          </p>
      </div>
      <el-table :data="busList" border header-cell-class-name="header-row" :cell-style="{textAlign: 'center'}">
        <el-table-column prop="line" label="公交线路" ></el-table-column>
        <el-table-column prop="station" label="下车地点"></el-table-column>
        <el-table-column prop="start" label="始发/终点站"></el-table-column>
        <el-table-column prop="time" label="首发/末班"></el-table-column>
        <el-table-column prop="fee" label="全部票价"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      metroList: [
          {
              line:"8号",
              station:"新港东、琶洲",
              start:"凤凰新村←→万胜围",
              time:"06:15-22:40",
              fee:"6元"
          }
      ],
      busList:[
          {
              line:"137",
              station:"琶洲、琶洲大桥南",
              start:"动物园南门(总站)←→新洲总站",
              time:"06:15-21:45",
              fee:"2元"
          },
          {
              line:"139",
              station:"琶洲、国际会展中心",
              start:"东圃客运站(总站)←→海珠客运站总站",
              time:"06:15-22:00",
              fee:"3元"
          },
          {
              line:"20",
              station:"琶洲、琶洲大桥南、国际会展中心",
              start:"岑村教练场总站←→赤岗大塘(总站)",
              time:"06:00-22:00",
              fee:"2元"
          },
          {
              line:"229",
              station:"琶洲、琶洲大桥南、国际会展中心",
              start:"罗冲围总站←→琶洲石基村总站",
              time:"06:00-22:00",
              fee:"2元"
          },
          {
              line:"262",
              station:"琶洲、琶洲大桥南、国际会展中心",
              start:"赤岗东(总站) ←→ 新洲总站",
              time:"05:50-22:30",
              fee:"2元"
          },
          {
              line:"507",
              station:"琶洲、琶洲大桥南、国际会展中心",
              start:"大学城总站←→黄埔区政府",
              time:"06:00-21:30",
              fee:"3元"
          },
           {
              line:"564",
              station:"琶洲、琶洲大桥南",
              start:"琶洲黄埔村总站←→天河客运站(总站)",
              time:"06:30-21:30",
              fee:"4元"
          },
           {
              line:"583",
              station:"琶洲、琶洲大桥南、国际会展中心",
              start:"逸景翠园总站←→车陂(总站)",
              time:"06:30-21:00",
              fee:"2元"
          },
           {
              line:"92",
              station:"琶洲、国际会展中心",
              start:"广州火车东站总站←→江海大道中",
              time:"06:30-22:00",
              fee:"2元"
          },
           {
              line:"大学城3线",
              station:"琶洲、琶洲大桥南、国际会展中心",
              start:"大学城总站←→广东药学院总站",
              time:"07:30-22:00",
              fee:"3元"
          },
           {
              line:"505",
              station:"琶洲、琶洲大桥南、国际会展中心",
              start:"塘村总站←→珠江泳场总站",
              time:"06:30-21:30",
              fee:"3元"
          },
          
      ]
    };
  },
  methods: {
    tableHeadClassName({row, rowIndex}) {
        console.log(row,rowIndex)
      return "head-row";
    },
    handelPre() {},
    handelNext() {},
    handelJump(path){
      this.$router.push(path)
    }
  }
};
</script>

<style lang="scss">
.traffic-container {
  width: 100%;
  .traffic_item {
      .traffic_type{
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          >div{
            min-width: 36px;
            // min-height: 36px;
            padding:15px;
            border-radius: 50%;
            box-sizing: border-box;
            background: #E16A13;
            color: #fff;
            margin-right: 17px;
            text-align: center;
            font-weight: bold;
            // line-height: 36px;
          }
          >span{
              font-size: 30px;
              color: #fff;
          }
          >p{
            font-size: 18px;
            margin:0;
          }
      }
  }
  .desc_wrap {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    color: #fff;
    margin-bottom: 102px;
    > span {
      color: rgba($color: #fff, $alpha: 0.5);
      font-size: 24px;
    }
  }
}

.title {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #fff;
  > h2 {
    font-size: 36px;
  }
  > span {
    color: rgba($color: #fff, $alpha: 0.5);
  }
}
.default_btn {
  background: rgba($color: #fff, $alpha: 0.2);
  border-radius: 30px;
  padding:18px;
  width:300px;
  text-align: center;
  color: rgba($color: #fff, $alpha: 0.5);
  font-size: 24px;
  margin: 60px auto;
}
.mb_80 {
  margin-bottom: 80px;
}
.header-row {
  background: #42abff !important;
  color: #fff;
  text-align: center !important;
}

@media screen and (max-width: 1000px) {
  .traffic-container {
    width: 100vw;
  }
}
</style>


// WEBPACK FOOTER //
// traffic.vue?7b9c60da